import { defineRecipe } from '@plurall/elo-v3';

export const essaysTabsRootRecipe = defineRecipe({
  className: 'essays-tabs',
  base: {
    marginBlockEnd: '1.5rem',

    "& [data-scope='tabs'][data-part='list'] [role='none']": {
      backgroundColor: 'border.primary',
    },

    '& .elo-tabs-trigger': {
      color: 'text.primary',
      fontSize: '14px',
      fontWeight: 400,

      '&[aria-selected="true"]': {
        color: 'text.brand',
        fontWeight: 600,
      },
    },
  },
});
